import { render } from "./support-tickets-modal.vue?vue&type=template&id=0b65e483"
import script from "./support-tickets-modal.vue?vue&type=script&lang=js"
export * from "./support-tickets-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__